/**
 * Mirrors automotive-api holiday catalog (HOLIDAY_ID / HOLIDAY_LABELS) for the dashboard UI.
 */

export const HOLIDAY_IDS = [
  'NEW_YEARS_DAY',
  'MLK_DAY',
  'PRESIDENTS_DAY',
  'MEMORIAL_DAY',
  'EASTER',
  'INDEPENDENCE_DAY',
  'LABOR_DAY',
  'VETERANS_DAY',
  'THANKSGIVING',
  'CHRISTMAS',
] as const

export type HolidayId = (typeof HOLIDAY_IDS)[number]

export const HOLIDAY_LABELS: Record<HolidayId, string> = {
  NEW_YEARS_DAY: "New Year's Day",
  MLK_DAY: 'Martin Luther King Jr. Day',
  PRESIDENTS_DAY: "Presidents' Day",
  MEMORIAL_DAY: 'Memorial Day',
  EASTER: 'Easter',
  INDEPENDENCE_DAY: 'Independence Day',
  LABOR_DAY: 'Labor Day',
  VETERANS_DAY: 'Veterans Day',
  THANKSGIVING: 'Thanksgiving Day',
  CHRISTMAS: 'Christmas Day',
}
